import React from "react";
import { useLocation } from "react-router-dom";
import { Link, Breadcrumbs, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, isMobile) => ({
  breadcrumbs: {
    marginTop: "103px",
    width: "100%",
    display: "flex",
    justifyContent: isMobile ? "center" : "flex-start",
    alignItems: "center",
    "& ol": {
      justifyContent: isMobile ? "center" : "flex-start",
    },
  },
  typography: {
    link: {
      color: "#868686",
      fontFamily: theme.typography.montserrat.regular,
      fontSize: "16px",
      "&:hover": {
        cursor: "pointer",
      },
    },
  },
});

const BreadCrumbs = () => {
  const isMobile = useMediaQuery("(max-width:899px)");
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);
  const location = useLocation();
  const { crumbsText } = useTranslation(location.pathname, "BreadCrumbs");

  const getEdition = () => {
    let courseLink = location.pathname.split("/")[2];
    let crumb;
    switch (true) {
      case location.search.includes("atr"):
        crumb = crumbsText[1].atr;
        break;
      case courseLink === "intro":
        crumb = crumbsText[1].introTeacher;
        courseLink += "/fechas";
        break;
      default:
        crumb = `${courseLink[0].toUpperCase()}${courseLink.slice(1)}`;
        courseLink += "/fechas";
    }

    return { crumb, courseLink };
  };

  return (
    <Breadcrumbs separator="|" sx={classes.breadcrumbs}>
      <Link underline="hover" sx={classes.typography.link} href="/aplica">
        {crumbsText[0]}
      </Link>
      <Link
        underline="hover"
        sx={classes.typography.link}
        href={`/aplica/${getEdition().courseLink}`}
      >
        {getEdition().crumb}
      </Link>
      <Link underline="hover" sx={classes.typography.link}>
        <b>{crumbsText[2]}</b>
      </Link>
    </Breadcrumbs>
  );
};

export default BreadCrumbs;
